import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataEcommercePurchaseInterface } from '../data/ecommerce-purchase.interface';
import { GtmStatsDataEntityInterface } from '../data/entity.interface';
import { DataKeyValueStringInterface } from '../../../data/key-value/string.interface';

export class GtmStatsAdapterEcommercePurchase implements StatsAdapterInterface {
  /**
   * Affiliation mapping with lead.medium and lead.cta
   */
  protected affiliationMapping: DataKeyValueStringInterface = {
    'phone-link': 'Display phone number',
    'phone-button': 'Call',
    'email-button': 'Email',
    'sms-button': 'SMS',
    'whatsapp-button': 'Whatsapp',
    'call_back-button': 'Callback',
  };

  /**
   *
   * @param entity
   * @param context
   */
  constructor(protected entity: GtmStatsDataEntityInterface, protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataEcommercePurchaseInterface {
    if (!this.context.global.currency) {
      throw new Error('Stats global context "currency" is not set.');
    }

    // Affiliation if lead is defined
    const affiliation =
      (this.context.local.lead &&
        this.affiliationMapping[this.context.local.lead.medium + '-' + this.context.local.lead.cta]) ||
      '';

    return {
      ecommerce: {
        purchase: {
          actionField: {
            action: 'purchase',
            id: String(this.entity.id),
            affiliation: affiliation,
            revenue: this.entity.price,
            list: this.entity.list,
          },
          products: [this.entity],
        },
        currencyCode: this.context.global.currency,
      },
      event: 'purchase',
    };
  }
}
